<template>
     <!-- style="display: none;" -->
    <div ref="pdf-ref" class="pdf-render-wrap" style="display: none;">
        <div class="pdf-render-box">
            <div class="pdf-render-content">
              <div class="pdf-render-item-middle-box">
                <div class="pdf-render-item-box">
                    <div class="amount-box">
                        <span>{{ `${refundBean.actualCurrency || '--'} ${refundBean.actualAmount || '--'}` }}</span>
                    </div>
                    <div class="pdf-render-item">
                        <p class="title">{{ $t("payment.refundInformation") }}</p>
                        <div class="item">
                            <span>{{ $t("t.amount") }}</span>
                            <div>
                                <span class="weight500">{{ `${refundBean.actualCurrency || '--'} ${refundBean.actualAmount || '--'}` }}</span>
                            </div>

                        </div>
                        <div class="item">
                            <span>{{ $t("tables.detailsInfo.transactionID") }}</span>
                            <span class="weight500">{{ refundBean.transactionId }}</span>
                        </div>
                        <div class="item">
                            <span>{{ $t("payment.paymentId") }}</span>
                            <span style="width: 50%;" class="weight500">{{ refundBean.paymentId }}</span>
                        </div>
                        <div class="item">
                            <span>{{ $t("payment.dateAndTime") }}</span>
                            <span class="weight500">{{ refundBean.dateAndTime }}</span>
                        </div>
                    </div>
                    <div class="pdf-render-item">
                        <p class="title">{{ $t("payment.receiverDetails") }}</p>
                        <div class="item">
                            <span>{{ $t("forms.wizard.name") }}</span>
                            <span style="width: 70%;" class="weight500">{{ refundBean.name }}</span>
                        </div>
                        <div class="item" v-if="refundBean.documentType && refundBean.documentNumber">
                            <span>{{ refundBean.documentType.toLocaleUpperCase() }}</span>
                            <span class="weight500">{{ refundBean.documentNumber }}</span>
                        </div>
                        <!-- <div class="item">
                            <span>Bank</span>
                            <span class="weight500">{{ refundBean.bank }}</span>
                        </div>
                        <div class="item">
                            <span>Account Type</span>
                            <span class="weight500">{{ refundBean.accountType }}</span>
                        </div>
                        <div class="item">
                            <span>Account No.</span>
                            <span class="weight500">{{ refundBean.accountNo }}</span>
                        </div> -->
                    </div>
                    <div class="pdf-render-item">
                        <p class="title">{{ $t("payment.payerDetails") }}</p>
                        <div class="item">
                            <span>{{ $t("payment.from") }}</span>
                            <span class="weight500">{{ refundBean.from }}</span>
                        </div>
                        <div class="item">
                            <span>{{ $t("payment.cnpj") }}</span>
                            <span class="weight500">{{ refundBean.cnpj }}</span>
                        </div>
                        <div class="item">
                            <span>{{ $t("payment.institution") }}</span>
                            <span class="weight500">{{ refundBean.institution }}</span>
                        </div>
                    </div>
                    <div class="pdf-render-footer">
                        <img :src="logoUrl" width="130" />
                        <a href="www.pagsmile.com" v-if="isTsWebsite">pagsmile.com</a>
                        <a href="www.luxtak.com" v-else-if="isLtWebsite">luxtak.com</a>
                    </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
    data() {
      return {}
    },
    props: {
      refundVoucher: {
        type: Object
      }
    },
    components: {
      pdf
    },
    computed: {
      logoUrl() {
          return require(`@/assets/images/${process.env.VUE_APP_WEBSETE_SIGN}Img/pdf_logo.png`)
      },
      isTsWebsite() {
        return process.env.VUE_APP_WEBSETE_SIGN === 'ps'
      },
      isLtWebsite() {
        return process.env.VUE_APP_WEBSETE_SIGN === 'lt'
      },
      refundBean() {
        return this.refundVoucher
      }
    },
    watch: {

    },
    setup() {}
}
</script>

<style lang="scss" scoped>
.pdf-render-wrap {
    position: relative;
    width: 900px;
    padding: 80px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.pdf-render-box {
    width: 370px;
    min-height: 500px;
    background-color: #012643;
    margin: 0 auto;

    .weight500 {
      font-weight: 500;
      color: #000000 !important;
    }

    .amount-box {
        text-align: center;
        font-size: 16px;
        color: $primary;
        padding: 19px 0;
        span:nth-child(1) {
          font-family: 'SpaceGrotesk-Regular';
          color: #2BC196;
          font-weight: 700;
        }
    }

    .pdf-render-content {
        width: 340px;
        height: auto;
        margin: 0 auto;
        padding: 15px 0;

        .pdf-render-item-middle-box {
          border-radius: 28px;
          border: 1px solid #8c8c8c;
          .pdf-render-item-box {
              overflow: hidden;
              width: 100%;
              min-height: 500px;
              border-radius: 28px;
              border: 6px solid #666666;
              background: #Fff;

              .title {
                  font-family: 'SpaceGrotesk-Regular';
                  font-weight: 500;
                  font-size: 16px;
                  color: #000000;
              }

              .pdf-render-item {
                  border-top: 1px solid rgba(0, 0, 0, 0.2);
                  font-size: 14px;
                  padding: 0 12px;

                  p {
                      text-align: center;
                      color: #2e2e2e;
                      margin: 20px 0;
                  }

                  .item {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      line-height: 18px;
                      margin-bottom: 18px;
                      font-family: 'SpaceGrotesk-Regular';

                      span {
                          word-wrap: break-word;
                      }

                      span:nth-child(1) {
                          width: 30%;
                          color: #303030;
                      }

                      span:nth-child(2) {
                          width: 44%;
                          text-align: right;
                      }
                  }
              }
          }
        }

    }

    .pdf-render-footer {
        text-align: center;
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        background-color: #F0FFF0;

        img {
          margin-top: 24px;
          margin-bottom: 10px;
          width: 91px;
          height: 19px;
        }

        a {
          color: #00C295;
          font-family: 'SpaceGrotesk-Regular';
          font-weight: 500;
          font-size: 12px;
          display: block;
          // color: $primary;
          font-size: 12px;
          padding-bottom: 24px;
        }
    }
}
</style>
